import { ErrorObject } from "@/models/Interfaces";
import { AxiosError, AxiosResponse } from "axios";

interface ValidationErrorObject {
  [key: string]: string[];
}

export class ApiResult<T> {
  error: AxiosError | null;
  errorMessage: string;
  errorCode: number | null = null;
  data: T | null;
  hasValidationError: boolean;

  constructor(err: Error | null, res: AxiosResponse<T> | undefined) {
    this.error = err as AxiosError;
    if (typeof this.error?.response?.data === "object" && this.error?.response?.data !== null) {
      this.errorMessage =
        this.error?.response?.data.detail ?? this.error?.response?.data.message ?? this.error?.response?.data.title ?? this.error.message;
      this.errorCode = this.error?.response?.data.errorCode || null;
    } else this.errorMessage = this.error?.response?.data;
    this.data = res?.data ?? null;
    this.errorMessage = this.errorMessage || (this.data as unknown as ErrorObject)?.error;
    this.errorCode = this.errorCode || (this.data as unknown as ErrorObject)?.errorCode || null;
    this.hasValidationError = this.error?.response?.data?.errors ? true : false;
  }

  validationErrorsList() {
    const errors = this.error?.response?.data?.errors as ValidationErrorObject;
    if (!errors || Array.isArray(errors)) return null;
    return Object.keys(errors).map((key) => ({
      key,
      msg: errors[key].join !== undefined ? errors[key]?.join(",") : "",
    }));
  }
}
